
import { defineComponent, nextTick, reactive, ref, toRefs, watch, computed, ComputedRef, createVNode, onMounted, onBeforeUnmount } from 'vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import store from '@/store'
import { message } from 'ant-design-vue'
import globalsets from '@/utils/globalsets'
import conditionstockApi from '@/api/conditionstockApi'
import Conditions from '@/views/conditionstock/conditions.vue'
import Mygroup from '@/views/conditionstock/mygroup.vue'
import type { ResultItemDataType } from './typings'
export default defineComponent({
  components: {
    Conditions,
    Mygroup
  },
  setup(props: any) {
    type pageDataType = {
      theme: string
      token: string
      getCalendarContainer: any | null
      radiovalue: number
      conditions: Array<any>
      editCondIdx: number
      groups?: Array<any>
      localData?: any
      local1?: any
      local2?: any
    }

    const route = useRoute()
    const myconditions = ref()
    const mygroup = ref()
    const pageData: pageDataType = reactive({
      getCalendarContainer: (e: HTMLElement) => e.parentNode,
      theme: (route.query.theme as string) || 'light',
      token: '',
      radiovalue: 0,
      conditions: [],
      editCondIdx: -1,
      groups: [],
      localData: null,
      local1: null,
      local2: null
    })
    async function gettoken() {
      pageData.token = await globalsets.getToken()
      pageData.conditions = await getHistogram()
      getGroups()
      getLocalData()
    }
    async function getHistogram() {
      const data = {
        data: {
          FundType: 31
        },
        headers: {
          token: pageData.token
        }
      }
      const res: any = await conditionstockApi.getReportDigFundHistogram(data)
      const { Data, Msg, Code } = res
      if (Code !== 0) {
        message.error(Msg)
        return
      }
      return Data
    }

    gettoken()
    function getLocalData() {
      // 读缓存
      const localData = localStorage.getItem('conditionstock')
      if (!localData) {
        pageData.localData = { noData: true }
        pageData.radiovalue = 1
        return
      }
      pageData.localData = JSON.parse(localData)
      pageData.radiovalue = pageData.localData.radiovalue
    }
    // 一加载就读所有组合，然后存起来
    function getGroups() {
      const url = 'gw://funccall?funcname=OnReadFundData;dirName=h5storagespace/conditionstock;fileName=condition.dat'
      window.open(url)
    }
    function ReadFunData(result: any) {
      if (result) {
        result = decodeURIComponent(result)
        pageData.groups = typeof result === 'string' ? JSON.parse(result) : result
      }
    }
    (window as any).ReadFunData = ReadFunData
    function jumpToGroup(type?: 'cancel'|'save') {
      pageData.editCondIdx = -1
      pageData.radiovalue = 2
      if (type === 'cancel') {
        // 编辑模式 取消编辑时跳转后需要重新筛选，不用获取groups
        mygroup.value.defaultPost()
      } else {
        getGroups()
        mygroup.value.setActive(0)
      }
    }
    function jumpToConditions(idx: number) {
      pageData.radiovalue = 1
      pageData.editCondIdx = idx
    }
    function refreshList() {
      getGroups()
    }

    function changeRadio(e: any) {
      nextTick(() => {
        if (e?.target?.value === 2) {
          mygroup.value.defaultPost()
        } else {
          myconditions.value.defaultPost()
          pageData.editCondIdx = -1
        }
      })
    }
    onMounted(() => {
      // 存
      // window.addEventListener('beforeunload', (e) => {
      //   const params1 = myconditions.value.setLocalStorage()
      //   const params2 = mygroup.value.setLocalStorage()
      //   const params = { radiovalue: pageData.radiovalue, ...params1, ...params2 }
      //   localStorage.setItem('conditionstock', JSON.stringify(params))
      // })
    })
    watch(
      () => [pageData.radiovalue, pageData.local1, pageData.local2],
      () => {
        const params = { radiovalue: pageData.radiovalue, ...pageData.local1, ...pageData.local2 }
        localStorage.setItem('conditionstock', JSON.stringify(params))
      }
    )
    function setLocal1(params) {
      pageData.local1 = params || pageData.local1
    }
    function setLocal2(params) {
      pageData.local2 = params || pageData.local2
    }

    watch(
      () => route.query.theme,
      (val: any) => {
        pageData.theme = val as string
      }
    )
    return {
      ...toRefs(pageData),
      jumpToConditions,
      jumpToGroup,
      changeRadio,
      mygroup,
      myconditions,
      refreshList,
      setLocal1,
      setLocal2
    }
  }
})
